import { useParameter } from "../../../shared";

export function useForecastFootnote() {
  const [commodity] = useParameter<number>('@commodities');
  const [sources] = useParameter<string[]>("@sources");

  switch (commodity) {
    case 201: return "Corn, no. 2, U.S. Gulf, USD/mt";
    case 701: return "Rapeseed, EU CIF, Hamburg, USD/mt";
    case 1001: return "Rice, no. 2, U.S., USD/mt";
    case 1101: return "Soybeans, no. 2, Yellow, Contract price, USD/mt";
    case 103: {
      const result: string[] = [];
      if (sources?.includes("nyse")) {
        result.push("Wheat, no. 2, Milling, Futures contract, USD/mt");
      }
      if (sources?.includes("facts_cbot_prices")) {
        result.push("Wheat, no. 2, SRW, Contract price, USD/mt");
      }
      return result.join('; ');
    };
    default: return "";
  }
}